import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE } from '@app/constants/Common';
import { capitalizeName, stringToOption } from '@app/utils/CommonUtils';
import { requestCandidates, getContactPointDetail } from '@app/services/CandidateService';
import { requestGetDVTJCUVPipeLineList } from '@pages/dvtjcuv/service/DVTJCUVPipelineService';
import { ReceiveRequestOptions, ReceiverCategoryOptions } from '@pages/candidate/detail/CandidateContactPoint';
import {
    InviteSendJobGpEmpProcessOptions,
    InviteSendJobTodoWRecOptions,
    ProcessPriorityOptions,
} from '@pages/dvtjcuv/common/Constant';

export const DVTJCUVPipelineRecPersonFields = [
    { key: 'cdd_receiver_id',                    label: 'Cdd Receiver ID',             inputType: 'number',   editable: true,  color: 'text-primary' },
    { key: 'cdd_receiver_full_name',             label: 'Họ và Tên',                   inputType: 'text',     editable: false, color: 'text-primary' },
    { key: 'cdd_receiver_displayed_company',     label: 'Displayed Company',           inputType: 'text',     editable: false, color: 'text-primary' },
    { key: 'cdd_receiver_displayed_title',       label: 'Displayed Title',             inputType: 'text',     editable: false, color: 'text-primary' },
    { key: 'cdd_receiver_local_province_email',  label: 'Loca tỉnh (email)',           inputType: 'text',     editable: false, color: 'text-primary' },
    { key: 'cdd_receiver_industry',              label: 'Industry',                    inputType: 'text',     editable: false, color: 'text-primary' },
    { key: 'cdd_receiver_function',              label: 'Function',                    inputType: 'text',     editable: false, color: 'text-primary' },
    { key: 'candidate_receive_request',          label: 'Yêu cầu nhận UV (DVTJCUV)',   inputType: 'option',   editable: true,  isMulti: true, options: ReceiveRequestOptions,    color: 'text-primary' },
    { key: 'cdd_receiver_category',              label: 'Phân loại as a Cdd Receiver', inputType: 'option',   editable: true,  isMulti: true, options: ReceiverCategoryOptions,  color: 'text-primary' },
];

export const DVTJCUVPipelineRecDiscussionFields = [
    { key: 'invite_send_job_gp_emp_process',    label: 'GP-Emp Process (mời gửi job)',  inputType: 'option',   isMulti: false, options: InviteSendJobGpEmpProcessOptions, editable: true, color: 'text-danger' },
    { key: 'invite_send_job_todo_w_rec',        label: 'To do with Rec (mời gửi job)',  inputType: 'option',   isMulti: false, options: InviteSendJobTodoWRecOptions,     editable: true, color: 'text-danger' },
    { key: 'rec_current_fu_strategy_date_time', label: '(REC) FU Strategy (This time)', inputType: 'text',                                                                  editable: true, color: 'text-success' },
    { key: 'rec_current_fu_campaign',           label: '(REC) FU Compaign (This time)', inputType: 'text',                                                                  editable: true, color: 'text-success' },
    { key: 'rec_next_fu_schedule_date_time',    label: '(REC) FU Schedule (Next time)', inputType: 'date',                                                                  editable: true, color: 'text-success' },
    { key: 'rec_next_fu_strategy_date_time',    label: '(REC) FU Strategy (Next time)', inputType: 'text',                                                                  editable: true, color: 'text-success' },
    { key: 'rec_next_fu_campaign',              label: '(REC) FU Compaign (Next time)', inputType: 'text',                                                                  editable: true, color: 'text-success' },
    { key: 'notes',                             label: 'Note',                          inputType: 'textarea',                                                              editable: true, color: 'text-info' },
    { key: 'process_priority',                  label: 'Ưu tiên xử lý',                 inputType: 'option',   isMulti: false, options: ProcessPriorityOptions,            editable: true, color: 'text-info' },
    { key: 'note_discussion_w_receiver',        label: 'Note Discussion w Receiver',    inputType: 'textarea',                                                              editable: true, color: 'text-info' },
];

const getProcessPriorityOption = (processPriority) => {
    if (processPriority) {
        return ProcessPriorityOptions.find(option => option.value.toString() === processPriority.toString());
    }
    return { label: '', value: '' };
};

const InputDiscussionWRecContent = (props) => {
    const { pipeLineInfo, onChangeInputItem, onLatestPipelineLoaded, onOriginalContactPointLoaded } = props;
    const [pipeline, setPipeline] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const fetchReceiverDetail = async (recId) => {
        if (!recId) return;
        const res = await requestCandidates({ search_conditions: { candidate_id: recId } });
        const can = res.content?.candidates?.[0];
        if (!can) return;

        setPipeline(prev => {
            const next = { ...prev, cdd_receiver_id: recId };
            if (can.personal) {
                next.cdd_receiver_full_name = capitalizeName(can.personal.full_name);
            }
            if (can.general) {
                next.cdd_receiver_displayed_company = can.general.displayed_company;
                next.cdd_receiver_displayed_title = can.general.displayed_title;
            }
            if (can.location) {
                next.cdd_receiver_local_province_email = can.location.local_province_email;
            }
            if (can.categories) {
                next.cdd_receiver_industry = can.categories.industry;
                next.cdd_receiver_function = can.categories.function;
            }
            return next;
        });
    };

    const fetchReceiverContactPoint = async (recId) => {
        if (!recId) return;
        const res = await getContactPointDetail(recId);
        const cp = res?.content?.contact_points || res?.data?.content?.contact_points || {};

        if (onOriginalContactPointLoaded) {
            onOriginalContactPointLoaded({
                candidate_receive_request: cp.candidate_receive_request || '',
                cdd_receiver_category: cp.cdd_receiver_category || '',
            });
        }

        setPipeline(prev => ({
            ...prev,
            candidate_receive_request: stringToOption(cp.candidate_receive_request, true),
            cdd_receiver_category: stringToOption(cp.cdd_receiver_category, true),
        }));
    };

    const fetchLatestPipelineByReceiver = async (recId) => {
        if (!recId) return;
        const res = await requestGetDVTJCUVPipeLineList({
            search_conditions: { cdd_receiver_id: recId },
            sort_columns: { created_date_time: ODER_BY_TYPE.DESC },
        });
        const latest = res.content?.pipelines?.[0];
        if (!latest) return;

        if (onLatestPipelineLoaded) onLatestPipelineLoaded(latest);

        setPipeline(prev => {
            const next = { ...prev };
            DVTJCUVPipelineRecDiscussionFields.forEach((col) => {
                if (col.inputType === 'option') {
                    if (col.key === 'process_priority') {
                        next[col.key] = getProcessPriorityOption(latest[col.key]);
                    } else {
                        next[col.key] = stringToOption(latest[col.key], col.isMulti);
                    }
                } else {
                    next[col.key] = latest[col.key];
                }
            });
            return next;
        });
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)));
        }
    }, []);

    useEffect(() => {
        const recId = pipeLineInfo?.cdd_receiver_id;
        if (recId) {
            fetchReceiverDetail(recId);
            fetchReceiverContactPoint(recId);
            fetchLatestPipelineByReceiver(recId);
        } else {
            setPipeline({});
        }
    }, [pipeLineInfo]);

    const onChangeInput = (values, column) => {
        const next = { ...pipeline, [column.key]: values };
        setPipeline(next);
        if (onChangeInputItem) onChangeInputItem(values, column);
    };

    const getItemValues = (column, values) => values || '';

    const disableDiscussionFields = (column) => {
        if (!column.editable) return true;
        return !pipeline.cdd_receiver_id;
    };

    const disablePersonField = (column) => {
        if (!column.editable) return true;
        if (column.key === 'cdd_receiver_id') {
            return Boolean(pipeLineInfo?.cdd_receiver_id);
        }
        // candidate_receive_request and cdd_receiver_category: editable only after receiver is bound.
        return !pipeline.cdd_receiver_id;
    };

    const onBlurReceiverId = async (event) => {
        if (event.target.name === 'cdd_receiver_id') {
            await fetchReceiverDetail(event.target.value);
            await fetchReceiverContactPoint(event.target.value);
            await fetchLatestPipelineByReceiver(event.target.value);
        }
    };

    const setFieldColorClass = (column) => column.color || '';

    return (
        <div className={'row'}>
            <div className={'col-sm-4'}>
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title text-bold">Thông tin Cdd Receiver</h3>
                    </div>
                    <div className="card-body row">
                        {DVTJCUVPipelineRecPersonFields.map((column) => {
                            if (column.inputType === 'option') {
                                return (
                                    <div className='col-sm-12' key={`rec_person_${column.key}`}>
                                        <div className='form-group'>
                                            <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                            <Select options={column.options}
                                                    value={getItemValues(column, pipeline[column.key])}
                                                    isDisabled={disablePersonField(column)}
                                                    name={column.key}
                                                    isMulti={!!column.isMulti}
                                                    onChange={(value) => onChangeInput(value, column)} />
                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <div className='col-sm-12' key={`rec_person_${column.key}`}>
                                    <div className='form-group'>
                                        <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                        <input type={column.inputType} className='form-control'
                                               disabled={disablePersonField(column)}
                                               onBlur={onBlurReceiverId}
                                               value={getItemValues(column, pipeline[column.key])}
                                               name={column.key}
                                               onChange={(event) => onChangeInput(event.target.value, column)} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className={'col-sm-8'}>
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title text-bold">Thông tin Discussion w Rec</h3>
                    </div>
                    <div className="card-body row">
                        {DVTJCUVPipelineRecDiscussionFields.map((column) => {
                            if (column.inputType === 'option') {
                                return (
                                    <div className='col-sm-6' key={`rec_disc_${column.key}`}>
                                        <div className='form-group'>
                                            <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                            <Select options={column.options}
                                                    value={getItemValues(column, pipeline[column.key])}
                                                    isDisabled={disableDiscussionFields(column)}
                                                    name={column.key}
                                                    isMulti={!!column.isMulti}
                                                    onChange={(value) => onChangeInput(value, column)} />
                                        </div>
                                    </div>
                                );
                            }
                            if (column.inputType === 'textarea') {
                                return (
                                    <div className='col-sm-6' key={`rec_disc_${column.key}`}>
                                        <div className='form-group'>
                                            <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                            <textarea className='form-control'
                                                      disabled={disableDiscussionFields(column)}
                                                      value={getItemValues(column, pipeline[column.key])}
                                                      name={column.key}
                                                      onChange={(event) => onChangeInput(event.target.value, column)} />
                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <div className='col-sm-6' key={`rec_disc_${column.key}`}>
                                    <div className='form-group'>
                                        <label className={`w-100 ${setFieldColorClass(column)}`}>{column.label}</label>
                                        <input type={column.inputType} className='form-control'
                                               disabled={disableDiscussionFields(column)}
                                               value={getItemValues(column, pipeline[column.key])}
                                               name={column.key}
                                               onChange={(event) => onChangeInput(event.target.value, column)} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InputDiscussionWRecContent;
